import { createReducer } from 'immutable-reducers';
import { fromJS, Map } from 'immutable';

import {serverUnitsToClientMap} from 'app/businessRules';
import * as actionTypes from '../constants/actionTypes';
import {VISITS, DELETE_VISIT, GET_UNITS, GET_GOODS, GET_DOCS} from '../constants/actionTypes';


export default createReducer(['visits'], (visits = Map(), action) => {
    let payload = action.payload;
    let unitIndex = 0;
    let index = 0;

    switch (action.type) {
        case actionTypes.VISIT_STORE_REQUEST:
            break;

        case actionTypes.VISIT_FETCH_SUCCESS:
        case actionTypes.VISIT_STORE_SUCCESS:
            let reg = visits.get(payload.id);
            if (!reg) {
                reg = fromJS(payload.data);
            } else {
                reg.mergeDeep(payload.data);
            }
            return visits.set(payload.id, reg);

        case VISITS.SUCCESS:
            return fromJS(action.visits);

        case DELETE_VISIT.SUCCESS:
            index = visits.findIndex(visit => visit.get('trac') === action.trac);
            return visits.delete(index);

        case GET_UNITS.SUCCESS:
            index = visits.findIndex(visit => visit.get('trac') === action.vtrac);
            return visits.setIn([index, 'units'], fromJS(action.units));

        case GET_GOODS.SUCCESS:
            unitIndex = 0;
            if (visits.count() === 0) {
                break;
            }

            index = visits.findIndex(visit => {
                if (!visit.has('units')) {
                    return false;
                }
                unitIndex = visit.get('units').findIndex(unit => unit.get('trac') === action.utrac);
                return unitIndex !== -1;
            });

            return visits.setIn([index, 'units', unitIndex, 'goods'], fromJS(action.goods));

        case GET_DOCS.SUCCESS:
            unitIndex = 0;
            if (visits.count() === 0) {
                break;
            }

            index = visits.findIndex(visit => {
                if (!visit.has('units')) {
                    return false;
                }
                unitIndex = visit.get('units').findIndex(unit => unit.get('trac') === action.utrac);
                return unitIndex !== -1;
            });

            return visits.setIn([index, 'units', unitIndex, 'docs'], fromJS(action.docs));

        case actionTypes.VISIT_STORE_FAILURE:
            break;

        default:
            break;
    }
    return visits;
});
